import React, { useContext, useState } from "react";
import { TransparentButton, classes } from "@bloomberg/media-ui-core";
import { ChevronDownThin, ChevronUpThin } from "@bloomberg/media-ui-icons";
import { ScreenContext } from "@foundation/screen";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";
import styles from "./keyStatistics.module.css";
import { QuoteData } from "~types/types";
import { getKeyStatistics } from "~utils";
import UpdateHighlight from "~components/UpdateHighlight";
import { TranslatedMessage, useTranslateMessage } from "~utils/i18n";

export type KeyStatisticsProps = {
  quoteData: QuoteData;
};

export default function KeyStatistics(props: KeyStatisticsProps) {
  const [viewLess, setViewLess] = useState<boolean>(false);
  const translateMessage = useTranslateMessage();
  const viewLessLabel = translateMessage({
    id: "viewLess",
    defaultMessage: "VIEW LESS",
  });
  const viewAllLabel = translateMessage({
    id: "viewAll",
    defaultMessage: "VIEW ALL",
  });
  const {
    breakpoints: { tablet },
  } = useContext(ScreenContext);

  const onViewAllButtonClick = () => {
    setViewLess(!viewLess);
  };
  const { quoteData } = props;
  const statisticsList = getKeyStatistics(quoteData, translateMessage);
  const nonNullStatisticValues = statisticsList.filter((stat) => {
    return stat.value !== null;
  });

  if (!nonNullStatisticValues || !nonNullStatisticValues.length) {
    return null;
  }

  const viewAllOrLessButton = () => {
    return (
      <TransparentButton
        ActionIcon={viewLess ? <ChevronUpThin /> : <ChevronDownThin />}
        className={styles.viewLess}
        name=""
        onClick={onViewAllButtonClick}
        size="small"
      >
        {viewLess ? viewLessLabel : viewAllLabel}
      </TransparentButton>
    );
  };

  return (
    <div>
      <h4
        className={classes([
          styles.keyStatsHeading,
          typographyStyles.coreHeadlineXs,
        ])}
      >
        <TranslatedMessage
          id={"keyStatistics"}
          defaultMessage={"Key Statistics"}
        />
      </h4>
      <div className={styles.keyStats}>
        {nonNullStatisticValues.map((row, index) => {
          if (row.value) {
            return (
              <div
                className={
                  !tablet && !viewLess && index > 4
                    ? styles.hiddenStatistic
                    : styles.keyStatisticPair
                }
                key={row.key}
              >
                <span
                  className={classes([
                    styles.key,
                    typographyStyles.coreShortTextXs,
                  ])}
                >
                  {row.key}
                </span>
                {quoteData.isRealTime ? (
                  <UpdateHighlight value={row.value} />
                ) : (
                  <span>{row.value}</span>
                )}
              </div>
            );
          }

          return null;
        })}
        {!tablet && nonNullStatisticValues.length > 4 && viewAllOrLessButton()}
      </div>
    </div>
  );
}
